module.exports = __webpack_public_path__ + "static/img/cancelLine.41d53f81.png";